export const SHOW_GETTING_STARTED_DIALOG = 'SHOW_GETTING_STARTED_DIALOG';
export const SHOW_SUPPORT_DIALOG = 'SHOW_SUPPORT_DIALOG';
export const SHOW_PRIVACY_POLICY_DIALOG = 'SHOW_PRIVACY_POLICY_DIALOG';

export const showGettingStartedDialog = (value) => ({
  type: SHOW_GETTING_STARTED_DIALOG,
  payload: value
});

export const showSupportDialog = (value) => ({
  type: SHOW_SUPPORT_DIALOG,
  payload: value
});

export const showPrivacyPolicyDialog = (value) => ({
  type: SHOW_PRIVACY_POLICY_DIALOG,
  payload: value
});
